import React, { Component } from 'react';
import { Redirect, Switch, Link, BrowserRouter, Route } from 'react-router-dom'
import Auth from './Auth';
import history from '../history';
import axios from 'axios';
import Autocomplete from 'react-autocomplete';

import EconForm1 from './EconForm1';
import EconForm2 from './EconForm1';
import EconForm3 from './EconForm1';
import EconForm4 from './EconForm1';
import EconForm5 from './EconForm1';
import EconForm6 from './EconForm1';

export default class Econ extends React.Component {

    constructor(props) {
        super(props);

        this.inputFio = this.inputFio.bind(this);
        this.submit = this.submit.bind(this);
        this.getForm = this.getForm.bind(this);

        this.state = {
            fio: '',
            listFioIsLoaded: false,
            listFio: [],
            paid1: 0,
            paid2: 0,
            paid3: 0,
            status: ''
        };
    };

    inputFio(e){
        this.setState({
            fio: e.target.value
        })
    }

    submit(){
        let data = {
            "fio" : this.state.fio,
            "paid1" : this.state.paid1,
            "paid2" : this.state.paid2,
            "paid3" : this.state.paid3
        }
        console.log('взяли из формы');
        console.log(data);
        data = JSON.stringify(data);
        //запись в БД
         axios
            .get("/server/addEcon.php?data="+data)
            .then((result) => {

              let id_pps = result.data;
              //console.log('С сервера:');
              //console.log(id_pps);
              id_pps = parseInt(id_pps);
              if(id_pps > -1){
                this.setState({
                  status: 'Данные успешно добавлены',
                  fio: '',
                  paid1: 0,
                  paid2: 0,
                  paid3: 0
                 })
                //скрытие уведомления о удачном push
                setTimeout(() => {
                  this.setState({
                    status: ''
                  })
                },2000)
                console.log("Успешно добавлен экономист с id: "+id_pps);
              } else {
                this.setState({
                  status: 'Ошибка: данные не были добавлены',
                  fio: '',
                  paid1: 0,
                  paid2: 0,
                  paid3: 0
                 })
                setTimeout(() => {
                  this.setState({
                    status: ''
                  })
                },2000)
              }
            });
    }

    getForm(){

    }

    componentWillMount(){
    //получение списка ФИО
       axios
          .get("/server/getListFio.php")
          .then((result) => {
            let list = result.data;
            list.pop();
            //console.log(list);

            this.setState({
                listFioIsLoaded: true,
                listFio: list
            });
          });
    }

    render() {
        if( this.props.role == 'econ' ){
            return (
            <div className='econ'>

              <div className='block-link'>
                  <Link className='link' to="/econForm1">Группа 1</Link>
                  <Link className='link' to="/econForm2">Группа 3,5</Link>
                  <Link className='link' to="/econForm4">Группа 3,5(Цапок В.А.)</Link>
                  <Link className='link' to="/econForm3">Группа 4,6</Link>
                  <Link className='link' to="/econForm5">Группа 4,6(Цапок В.А.)</Link>
              </div>

            </div>
            );
        } else {
            history.push('/auth');
            return ('');
        }
    }
}



// WEBPACK FOOTER //
// ./src/component/Econ.js